import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, CardBody, FormGroup, Label, Input, Button, InputGroup, InputGroupText, Spinner, Alert } from 'reactstrap';
import { useParams, useNavigate, Link } from 'react-router-dom';

const ExpenseEntry = () => {
    document.title = "Masraf Girişi | HarmanaGEL";
    const { id } = useParams();
    const navigate = useNavigate();

    const authUser = JSON.parse(localStorage.getItem("authUser") || "{}");
    const userId = authUser?.ID;

    const [loading, setLoading] = useState(false);
    const [fuel, setFuel] = useState("");
    const [toll, setToll] = useState("");
    const [transport, setTransport] = useState("");
    const [taxi, setTaxi] = useState("");
    const [exceptional, setExceptional] = useState("");

    // Toplam masraf hesaplama
    const totalExpenses = (
        parseFloat(fuel || '0') +
        parseFloat(toll || '0') +
        parseFloat(transport || '0') +
        parseFloat(taxi || '0') +
        parseFloat(exceptional || '0')
    ).toFixed(2);

    useEffect(() => {
        const loadInitialData = async () => {
            if (!userId || !id) return;
            try {
                const response = await fetch(`https://harmanagelapi.stechomeyazilim.info/ODEME_LOGLARI?$filter=ILANLAR_ID eq ${id} and KULLANICI_ID eq ${userId}`);
                const result = await response.json();
                
                if (result.value && result.value.length > 0) {
                    const existingData = result.value[0];
                    setFuel(existingData.Fuel_Expense?.toString() || "");
                    setToll(existingData.Toll_Fee?.toString() || "");
                    setTransport(existingData.Public_Transport?.toString() || "");
                    setTaxi(existingData.Taxi_Expense?.toString() || "");
                    setExceptional(existingData.Exceptional_Expense?.toString() || "");
                }
            } catch (error) {
                console.error("Veri yükleme hatası:", error);
            }
        };
        loadInitialData();
    }, [id, userId]);

    const handleSaveExpense = async () => {
        setLoading(true);
        try {
            const payload = {
                Advert_ID: Number(id),
                Users_ID: Number(userId),
                Fuel_Expense: parseFloat(fuel || "0"),
                Toll_Fee: parseFloat(toll || "0"),
                Public_Transport: parseFloat(transport || "0"),
                Taxi_Expense: parseFloat(taxi || "0"),
                Exceptional_Expense: parseFloat(exceptional || "0"),
                Total_Expense: parseFloat(totalExpenses),
                OLUSTURMA_TARIHI: new Date().toISOString()
            };

            const response = await fetch("https://harmanagelapi.stechomeyazilim.info/ODEME_LOGLARI", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload)
            });

            if (!response.ok) throw new Error("Masraf kaydedilemedi");

            // Başarılıysa 2. adıma masraf bilgisini (state ile) göndererek yönlendir
            navigate(`/final-offer/${id}`, { state: { expenses: parseFloat(totalExpenses) } });

        } catch (error) {
            console.error("Hata:", error);
            alert("Masraf kaydedilirken bir hata oluştu!");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="page-content">
            <Container fluid>
                <div className="d-flex align-items-center mb-4">
                    <Link to={`/job-details/${id}`} className="text-dark me-3">
                        <i className="mdi mdi-arrow-left fs-3"></i>
                    </Link>
                    <h3 className="mb-0">Masraf Girişi n°{id}</h3>
                </div>

                <Row className="justify-content-center">
                    <Col lg={8}>
                        <Card className="border shadow-none mb-4 bg-light">
                            <CardBody className="d-flex justify-content-between align-items-center">
                                <div>
                                    <h5 className="mb-1 text-primary"><i className="mdi mdi-calculator me-2"></i>TOPLAM MASRAF</h5>
                                    <p className="text-muted mb-0">Tüm kalemlerin toplamı</p>
                                </div>
                                <h2 className="mb-0 text-primary">{totalExpenses} <span className="fs-5 text-muted">TL</span></h2>
                            </CardBody>
                        </Card>

                        <Alert color="warning" className="border-0 bg-warning bg-opacity-10 text-warning d-flex align-items-center">
                            <i className="mdi mdi-alert-circle-outline fs-4 me-2"></i>
                            Faturanızın doğruluğu için tüm masrafları detaylandırmanız önerilir.
                        </Alert>

                        <Card>
                            <CardBody>
                                <h5 className="card-title mb-4">Gider Kalemleri</h5>
                                
                                <ExpenseInput label="Yakıt Masrafı" icon="gas-station" value={fuel} onChange={setFuel} />
                                <ExpenseInput label="Otoyol Ücreti" icon="road-variant" value={toll} onChange={setToll} />
                                <ExpenseInput label="Toplu Taşıma" icon="bus" value={transport} onChange={setTransport} />
                                <ExpenseInput label="Taksi Gideri" icon="taxi" value={taxi} onChange={setTaxi} />
                                <ExpenseInput label="İstisnai Masraflar" icon="alert-circle" value={exceptional} onChange={setExceptional} />

                                <div className="text-end mt-4">
                                    <Button color="primary" size="lg" onClick={handleSaveExpense} disabled={loading}>
                                        {loading ? <Spinner size="sm" /> : <>Devam Et <i className="mdi mdi-chevron-right ms-1"></i></>}
                                    </Button>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

// Yardımcı Input Komponenti
const ExpenseInput = ({ label, icon, value, onChange }) => (
    <FormGroup className="mb-3">
        <Label className="text-muted text-uppercase fw-bold" style={{fontSize: "12px"}}>{label}</Label>
        <InputGroup>
            <InputGroupText className="bg-light"><i className={`mdi mdi-${icon} text-primary`}></i></InputGroupText>
            <Input 
                type="number" 
                placeholder="0.00" 
                value={value} 
                onChange={e => onChange(e.target.value)} 
                className="fs-5 fw-bold"
            />
            <InputGroupText className="bg-light fw-bold text-muted">TL</InputGroupText>
        </InputGroup>
    </FormGroup>
);

export default ExpenseEntry;